<template>
    <v-sheet>
        <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
            경력사항
            <span v-if="mode == 'form'" class="page-text--sm grey-6--text pl-8 font-weight-regular">경력 작성시 더 좋은 일자리를 구할 수 있습니다.</span>
        </h5>

        <v-sheet>
            <v-divider class="primary border-2" />
            <vertical-table-row term="경력구분" :required="mode == 'form'">
                <template v-if="mode == 'form'">
                    <v-row class="row--small">
                        <v-col cols="12" md=""> <v-select v-model="resume.workExperience.type" :items="types" :menuProps="{ attach: `.workExperience-type-${className}` }" :class="`workExperience-type-${className}`" v-bind="attrs_input" @change="onChangeWorkExperienceType" /> </v-col>
                        <template v-if="resume.workExperience.type == WORK_EXPERIENCES.EXPERIENCED.value">
                            <v-col cols="6" md=""> <v-currency-field v-model="resume.workExperience.span.years" :max="99" suffix="년" v-bind="attrs_input" @input="emit" /> </v-col>
                            <v-col cols="6" md=""> <v-currency-field v-model="resume.workExperience.span.months" :max="11" suffix="개월" v-bind="attrs_input" @input="emit" /> </v-col>
                        </template>
                    </v-row>
                </template>
                <template v-else>
                    <p class="page-text grey--text">{{ workExperienceType }}</p>
                </template>
            </vertical-table-row>

            <template v-for="(item, index) in resume.workExperience.list">
                <v-divider class="primary border-2 mt-12 mt-lg-20" :key="index" />
                <vertical-table-row term="근무형태" :key="`${item.tempId}-type`">
                    <template v-if="mode == 'form'">
                        <v-row align="center">
                            <v-col>
                                <v-select v-model="item.type" :items="employmentTypes" :menuProps="{ attach: `.employmentType-${className}-${index}` }" :class="`employmentType-${className}-${index}`" v-bind="attrs_input" @input="emit" />
                            </v-col>
                            <v-col cols="auto">
                                <v-btn icon color="grey-f8" class="v-btn--minus" @click="remove(item)"> <v-icon>mdi-minus</v-icon> </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <p class="page-text grey--text">{{ getTypeText(item) }}</p>
                    </template>
                </vertical-table-row>
                <vertical-table-row term="회사명" :key="`${item.tempId}-companyName`">
                    <template v-if="mode == 'form'">
                        <v-row no-gutters align="center">
                            <v-col>
                                <v-text-field v-model="item.companyName" v-bind="attrs_input" @input="emit" />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <p class="page-text grey--text">{{ item?.companyName }}</p>
                    </template>
                </vertical-table-row>
                <vertical-table-row term="근무기간" :key="`${item.tempId}-duration`">
                    <template v-if="mode == 'form'">
                        <v-row align="center" class="row--small">
                            <v-col> <v-text-field v-model="item.duration.startsAt" type="date" max="2999-12-31" label="시작일" v-bind="attrs_input" @input="emit" /> </v-col>
                            <v-col class="px-10" cols="auto"> ~ </v-col>
                            <v-col> <v-text-field v-model="item.duration.endsAt" type="date" max="2999-12-31" label="종료일" v-bind="attrs_input" @input="emit" /> </v-col>
                        </v-row>
                    </template>
                    <template v-else-if="item?.duration?.startsAt || item?.duration?.endsAt"> {{ item?.duration?.startsAt }} ~ {{ item?.duration?.endsAt }} </template>
                </vertical-table-row>
                <vertical-table-row term="담당업무" :key="`${item.tempId}-description`">
                    <template v-if="mode == 'form'">
                        <v-textarea v-model="item.description" v-bind="attrs_input" @input="emit" />
                    </template>
                    <template v-else>
                        <p class="page-text grey--text">{{ item?.description }}</p>
                    </template>
                </vertical-table-row>
            </template>
        </v-sheet>

        <template v-if="mode == 'form'">
            <v-btn block color="grey-f8" class="v-btn--plus rounded-lg" @click="addItem"> <i class="icon icon-plus-sm" /> </v-btn>
        </template>
    </v-sheet>
</template>

<script>
import { attrs_input, EMPLOYMENT_TYPES, initResume, initWorkExperienceItem, WORK_EXPERIENCES } from "@/assets/variables";

import VerticalTableRow from "@/components/dumb/vertical-table-row.vue";

const types = Object.values(WORK_EXPERIENCES);
const employmentTypes = Object.values(EMPLOYMENT_TYPES);

export default {
    components: {
        VerticalTableRow,
    },
    props: {
        value: { type: Object, default: initResume }, // resume
        mode: { type: String, default: "form" },
    },
    data: () => ({
        resume: initResume(),

        types,
        attrs_input,
        employmentTypes,
        WORK_EXPERIENCES,
        className: Math.random().toString().slice(2),
    }),
    computed: {
        workExperienceType() {
            let text = "";

            const type = WORK_EXPERIENCES[this.resume?.workExperience?.type]?.text;
            if (type) text += `${type} `;

            let { years, months } = this.resume?.workExperience?.span || {};
            if (years || months) {
                if (text) text += " / ";

                if (years) years = `${years.format?.()}년`;
                if (months) months = `${months.format?.()}개월`;

                text += [years, months].filter((item) => item).join(" ");
            }

            return text.trim();
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.resume = { ...initResume(this.value) };
        },
        emit() {
            let { workExperience } = this.resume;
            this.$emit("input", { ...this.value, workExperience });
        },
        addItem() {
            this.resume.workExperience.list.push({ ...initWorkExperienceItem(), tempId: Math.random() });
            this.emit();
        },
        remove(item) {
            this.resume.workExperience.list = this.resume.workExperience.list.filter(({ tempId }) => tempId != item.tempId);
            this.emit();
        },
        getTypeText(item) {
            return EMPLOYMENT_TYPES[item?.type]?.text;
        },
        onChangeWorkExperienceType(type) {
            if (type == WORK_EXPERIENCES.NEW_RECRUIT.value) {
                this.resume.workExperience.span.years = 0;
                this.resume.workExperience.span.months = 0;
            }
            this.emit();
        },
    },
};
</script>

<style lang="scss" scoped>
.row--small {
    margin: -5px -2px;
    > [class*="col"] {
        padding: 5px 2px;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .row--small {
        margin: -5px;
        > [class*="col"] {
            padding: 5px;
        }
    }
}
@media (min-width: 1200px) {
}
</style>